(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/init.js');
'use strict';

const {
  PlayerRouter
} = svs.app.ReactRouter;
const {
  baseUrl
} = svs.core.data;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  Routes
} = svs.playerLoginReact;
const {
  HeaderLogo,
  MainPage
} = svs.playerLoginReact.sharedComponents;
const {
  PlayerLoginReactReduxProvider
} = svs.playerLoginReact.store;
svs.playerLoginReact.init = () => {
  const router = React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(PlayerLoginReactReduxProvider, null, React.createElement(ErrorBoundary, null, React.createElement(HeaderLogo, null), React.createElement(MainPage, null, React.createElement(Routes, null)))));
  ReactDOM.render(router, document.getElementsByClassName('js-react-container')[0]);
};
svs.playerLoginReact.init();

 })(window);